import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const PrintCard = React.forwardRef((props, ref) => {
  const { t } = useTranslation("dashboard");
  const [activationCode, setActivationCode] = useState("");

  useEffect(() => {
    let newCode = "";
    if (props?.product?.includes("Mobilis")) newCode = "* 111 *" + newCode;
    else if (props?.product?.includes("Djezzy")) newCode = "* 700 *" + newCode;
    else if (props?.product?.includes("Ooredoo")) newCode = "* 222 *" + newCode;

    setActivationCode(newCode);
  }, [props?.code, props?.product]);

  return (
    <div ref={ref} className="m-[10px] border-dashed border w-64 text-sm p-2">
      <div className="h-24 flex justify-center items-center flex-col">
        <img
          className="mt-4 w-7/12"
          src="/images/logo/hblogotitle.png"
          alt="Digital Home Logo"
        />
        <p>www.digital-home.org</p>
      </div>
      <p>------------------------------------</p>
      <div className="space-y-1">
        <p className="text-xs">
          Store: <span className="font-bold">{props?.currentUser}</span>
        </p>
        <p>
          Product: <span className="font-bold">{props?.product}</span>
        </p>

        {props?.serialNumber != null && (
          <p>
            Serial Number:{" "}
            <span className="font-bold">{props?.serialNumber}</span>
          </p>
        )}

        <p>--------------CODE----------------</p>
        <p className="font-bold text-lg text-center">
          {props?.code?.match(/.{1,4}/g).join(" ")}
        </p>
        <p>------------------------------------</p>

        {/* Replaced <p> with <div> to prevent invalid nesting */}
        <div className="pb-2 font-bold">
          {activationCode && (
            <div className="flex justify-center">
              <p className="text-xs text-right">
                {t("print_card.activation_code", { activationCode })}
              </p>
            </div>
          )}
          {(props?.product?.includes("ADSL") ||
            props?.product?.includes("4G")) && (
            <div className="flex justify-center">
              <p className="text-xs">{t("print_card.landline_instructions")}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

PrintCard.displayName = "PrintCard";
export default PrintCard;
